module.exports = __webpack_public_path__ + "js/0.24fd1c20.worker.js"